import {api} from '../services/api'
import {
  FaceOffGoldenSummary,
  FaceOffGoldenVersion,
} from '../services/coreApi/faceoff'
import {FaceOffLoadState, useFaceOffLoad} from './useFaceOffRun'

/**
 * Loads the golden version list, newest first. A new `reloadKey` reloads it,
 * so a screen can refresh the list after an edit writes a version.
 */
export const useFaceOffGoldenVersions = (
  reloadKey = 'versions',
): FaceOffLoadState<FaceOffGoldenSummary[]> =>
  useFaceOffLoad(reloadKey, () => api.faceoff.getFaceOffGoldenVersions())

/** Loads one golden version. */
export const useFaceOffGoldenVersion = (
  version: number,
): FaceOffLoadState<FaceOffGoldenVersion> =>
  useFaceOffLoad(String(version), () =>
    api.faceoff.getFaceOffGoldenVersion(version),
  )
